import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CTADeclaration() {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, "_blank", "noopener,nofollow");
    }
  };

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">
            A Planilha Oficial
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-primary-500 mt-4 leading-tight">
            Melhor CSSBuy Spreadsheet
            <br />
            Atualizado 2026
          </h2>
          <p className="text-foreground-600 text-base md:text-lg mt-6 leading-relaxed max-w-xl">
            Mais de 500 links verificados, atualizados semanalmente. A planilha
            mais completa em português para comprar da China com segurança e os
            melhores preços.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 text-white font-semibold px-8 py-3.5 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 text-center"
            >
              cssbuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="border-2 border-primary-500 text-primary-600 font-semibold px-8 py-3.5 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-50 transition-all duration-200 text-center"
            >
              buy it now
            </a>
          </div>

          <div className="mt-10 relative w-full max-w-md">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-white border-2 border-primary-300 rounded-full px-6 py-3.5 text-foreground-700 text-sm font-medium cursor-pointer focus:outline-none focus:border-primary-500 transition-colors duration-200"
            >
              <option value="">-- Selecionar Categoria --</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.url}>
                  {cat.namePt} ({cat.name})
                </option>
              ))}
            </select>
            <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-foreground-500"></i>
            </div>
          </div>

          <div className="flex flex-wrap gap-5 mt-10">
            <span className="text-foreground-500 text-sm whitespace-nowrap">
              <i className="ri-shield-check-line text-primary-500 mr-1"></i> Links verificados
            </span>
            <span className="text-foreground-500 text-sm whitespace-nowrap">
              <i className="ri-refresh-line text-primary-500 mr-1"></i> Atualizado semanalmente
            </span>
            <span className="text-foreground-500 text-sm whitespace-nowrap">
              <i className="ri-global-line text-primary-500 mr-1"></i> Guias em português
            </span>
            <span className="text-foreground-500 text-sm whitespace-nowrap">
              <i className="ri-star-line text-primary-500 mr-1"></i> Produtos populares
            </span>
          </div>
        </div>

        <div className="mt-12 md:mt-16 bg-primary-50 rounded-3xl p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950">
                Como Usar CSSBuy em 2026 (Guia Completo)
              </h3>
              <p className="text-foreground-600 text-sm md:text-base mt-3 leading-relaxed">
                Aprende tudo sobre CSSBuy: desde criar a tua conta, encontrar os
                melhores produtos, entender o sistema de QC, escolher o melhor
                frete para Portugal e Brasil, e evitar problemas na alfândega.
                Guia completo e atualizado para 2026.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 mt-6">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="bg-primary-500 text-white font-semibold px-6 py-2.5 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 text-center"
                >
                  Acessar a Planilha
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="bg-white text-foreground-700 font-medium px-6 py-2.5 rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all duration-200 text-center border border-background-200"
                >
                  Ver Todos os Links
                </a>
              </div>
            </div>
            <div className="w-full md:w-[240px] h-[200px] md:h-[220px] rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20workspace%20with%20laptop%20spreadsheet%2C%20warm%20natural%20light%2C%20olive%20green%20ceramic%20cup%2C%20minimalist%20desk%2C%20soft%20textures%2C%20editorial%20photography%2C%20cozy%20professional%20atmosphere%2C%20terracotta%20accents&width=480&height=440&seq=cta-guide-v2&orientation=landscape"
                alt="Guia CSSBuy 2026"
                title="Guia Completo CSSBuy 2026"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}